
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/lean/done",
      function () {
        return require("private-next-pages/download/lean/done/index.tsx");
      }
    ]);
  